import type { DataErrorRepository } from '../data/data-error-repository';
import type { DataErrorFilters } from '../types/data-error-types';

export class ExportIrregularDeltaUseCase {
  constructor(private readonly repository: DataErrorRepository) {}

  async execute(
    filters: DataErrorFilters
  ): Promise<{ blob: Blob; hasError: false } | { hasError: true; errorMessage: string }> {
    try {
      const blob = await this.repository.exportExcel(filters);
      return { blob, hasError: false };
    } catch (error: unknown) {
      return {
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Export failed',
      };
    }
  }
}
